  // 2026-07-23 fix (rewrite — previous approach here confirmed NOT to work):
  // "Your cart is Empty" (or a stale item list) flashes up before the real
  // cart contents appear, for ANY add-to-cart on the site. The original fix
  // here wrapped window.emit, hoping to delay 'quick-cart:open' until a
  // pending 'quick-cart:updated' refresh had landed. Reading theme.js
  // directly confirmed this could never have worked: `window.emit` (set at
  // `window.emit = r$1` inside the header component's onLoad) is a one-way,
  // one-time EXPORT of theme.js's internal pub/sub emit function — every
  // native call site in theme.js (the plain-product add-to-cart submit
  // handler, the header cart-icon click, the purchase-confirmation "view
  // cart" button) calls that internal `r$1` reference directly, never
  // `window.emit`. Wrapping `window.emit` therefore only ever intercepted
  // calls made by OUR OWN code (arlo-options.js), which didn't need it —
  // openQuickCartWhenReady() there already handles that path correctly. The
  // actual native-flow race was never touched by any version of this wrap,
  // which is why every round of adjusting it produced no change at all.
  //
  // New approach: instead of trying to delay WHEN the drawer opens (which
  // requires intercepting an internal call we can't reach), mask WHAT'S
  // VISIBLE while it's open but a refresh we know is pending hasn't landed
  // yet. The instant we see real evidence an add/remove happened —
  // 'cart:item-added' (dispatched as a genuine DOM CustomEvent by BOTH
  // theme.js's native addItem() and arlo-options.js's custom flow — unlike
  // 'quick-cart:updated', this one is NOT internal-pub-sub-only, so it's a
  // reliable, reachable signal) — add a class to the drawer that hides its
  // content via CSS (see .arlo-drawer-pending in sections/quick-cart.liquid).
  // That file removes the class once IT confirms fresh content has actually
  // landed (dispatches 'arlo:cart-fresh' from the same place it already
  // trusts for its own qty/remove loading-overlay logic). A hard safety
  // timeout means this can never get stuck masking the drawer indefinitely
  // even if that signal is missed for some reason.
  (function () {
    var wrapper;
    var safetyTimer = null;

    function wrapperEl() {
      if (!wrapper) wrapper = document.querySelector('.quick-cart');
      return wrapper;
    }

    function markPending() {
      var el = wrapperEl();
      if (!el) return;
      el.classList.add('arlo-drawer-pending');
      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(clearPending, 1800);
    }

    function clearPending() {
      clearTimeout(safetyTimer);
      var el = wrapperEl();
      if (el) el.classList.remove('arlo-drawer-pending');
    }

    document.addEventListener('cart:item-added', markPending);
    document.addEventListener('cart:updated', markPending);
    document.addEventListener('arlo:cart-fresh', clearPending);
  })();

  // ── Cart drawer height pin (iOS Safari dynamic toolbar) ─────────────────────
  // Sequence that broke: close drawer -> scroll page (Safari toolbar hides,
  // viewport grows) -> reopen drawer -> gap at the bottom. CSS dvh only
  // partially tracks this on iOS when the toolbar state changed BEFORE the
  // drawer opened. Deterministic fix: the moment the drawer gains .active,
  // pin the wrapper to the CURRENT window.innerHeight in px, and keep
  // re-pinning on any viewport resize while open (toolbar show/hide fires
  // resize). On close, clear the inline height so the CSS (inset + dvh)
  // takes back over.
  (function () {
    var wrap = null;
    function el() {
      if (!wrap || !document.body.contains(wrap)) wrap = document.querySelector('.quick-cart__wrapper');
      return wrap;
    }
    function size() {
      var w = el();
      if (w && w.classList.contains('active')) w.style.height = window.innerHeight + 'px';
    }
    function clearH() {
      var w = el();
      if (w) w.style.height = '';
    }
    document.addEventListener('DOMContentLoaded', function () {
      var w = el();
      if (!w || !window.MutationObserver) return;
      new MutationObserver(function () {
        if (w.classList.contains('active')) { size(); } else { clearH(); }
      }).observe(w, { attributes: true, attributeFilter: ['class'] });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', size);
      window.addEventListener('resize', size);
      window.addEventListener('orientationchange', function () { setTimeout(size, 250); });
    });
  })();

  document.addEventListener('DOMContentLoaded', function() {
    // Hide testimonials if client has closed them (cookie exists)
    var seenPT = getCookieJS("closePT");
    if (seenPT !== "") {
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '#pTestimonials { display:none !important}';
      document.head.appendChild(style);
      console.log("Hide PT");
    }

    // Handle closing testimonials
    document.querySelector('#pTestimonials .prClose')?.addEventListener('click', function() {
      setCookieJS("closePT", true, 1); // Set cookie to stop testimonials showing for 1 day
    });

    // Handle checkbox for notes
    var chkNotes = document.getElementById('chkNotes');
    if (chkNotes) {
      chkNotes.addEventListener('change', function() {
        var updateCart = document.getElementById('update-cart');
        if (chkNotes.checked) {
          updateCart.classList.add('notes-open');
        } else {
          updateCart.classList.remove('notes-open');
        }
      });
    }

    // Handle keyup for font preview
    var fontPreviewText = document.getElementById('font-preview-text');
    if (fontPreviewText) {
      fontPreviewText.addEventListener('keyup', updateFontPreview);
    }

    // Initialize FAQs click events
    initFAQs();
  });

  // Update font preview text
  function updateFontPreview() {
    var val = document.getElementById('font-preview-text').value;
    document.querySelectorAll('.preview-text').forEach(function(preview) {
      preview.textContent = val;
    });
  }

  // Initialize FAQ section
  function initFAQs() {
    document.querySelectorAll(".faqs h3").forEach(function(header) {
      header.addEventListener("click", function() {
        var content = header.nextElementSibling;
        if (content && content.classList.contains("faqContent")) {
          content.style.display = content.style.display === 'none' ? 'block' : 'none';
        }
      });
    });
  }

  // ── Arlo cart property enhancer ─────────────────────────────────────────────
  // Scans the entire document for ucarecdn.com URLs in text nodes and replaces
  // them with thumbnail images. Works with any cart app (Unicorn, theme, etc.)
  (function arloCartPreviews() {
    var UCARECDN_RE = /https?:\/\/ucarecdn\.com\/[^\s"'<>]+/;

    // Arch crop shape — same CSS-illusion approach as circle, matching the
    // aspect ratio + border-radius used in arlo-photo-uploader.js's ARCH_ASPECT/ARCH_RADIUS.
    // MUST stay numerically identical to that file (and to admin/public/index.html's
    // ARCH_ASPECT) — this was previously 41% here vs 40% there, a silent mismatch that
    // made the cart thumbnail's curve very slightly different from the live crop tool's.
    // Correct value = (ARCH_ASPECT / 2) * 100 = 40.5% for ARCH_ASPECT = 0.81.
    var ARCH_RADIUS = '50% 50% 4px 4px / 40.5% 40.5% 4px 4px';

    // 'Decal Arch' — a second arch-style shape (same round-top/flat-sides outline,
    // same CSS-radius technique) at a narrower/taller fixed ratio (0.75). Must stay
    // numerically identical to DECAL_ARCH_ASPECT/DECAL_ARCH_RADIUS in
    // assets/arlo-photo-uploader.js and admin/public/index.html.
    var DECAL_ARCH_ASPECT = 0.75;
    var DECAL_ARCH_RADIUS = '50% 50% 4px 4px / 37.5% 37.5% 4px 4px'; // (0.75 / 2) * 100

    var styleEl = document.createElement('style');
    styleEl.textContent =
      '.arlo-cp-thumb{display:block;width:100%;margin-top:6px;max-width:240px;border-radius:4px;border:1px solid #000 !important}' +
      '.arlo-cp-thumb--circle{width:100px;height:100px;max-width:none;object-fit:cover;border-radius:50%}' +
      '.arlo-cp-thumb--arch{width:100px;height:123px;max-width:none;object-fit:cover;border-radius:' + ARCH_RADIUS + '}' +
      '.arlo-cp-thumb--decal-arch{width:100px;height:133px;max-width:none;object-fit:cover;border-radius:' + DECAL_ARCH_RADIUS + '}' +
      // Grid layout for multi-photo line items — always 4 across
      '.arlo-cp-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin-top:6px}' +
      // Each grid thumb capped at 75% of its column (25% smaller per image) and
      // centered, while the grid itself stays 4-across at its original width.
      // 2026-07-26: aspect-ratio 1/1 -> auto. Uploaded files are ALREADY cropped
      // to their chosen shape (single rect photos rendered correctly, proving
      // it), so forcing 1/1 here squared off rectangle crops in multi-photo
      // grids. auto shows each file's true crop; circle files are square so
      // they still render round via their class, arch/decal-arch keep their
      // overrides below.
      '.arlo-cp-grid .arlo-cp-thumb{margin-top:0;width:60%;height:auto;aspect-ratio:auto;max-width:none;object-fit:cover;border:1px solid #000 !important;justify-self:center;align-self:start}' +
      '.arlo-cp-grid .arlo-cp-thumb--circle{border-radius:50%}' +
      '.arlo-cp-grid .arlo-cp-thumb--arch{aspect-ratio:0.81;border-radius:' + ARCH_RADIUS + '}' +
      '.arlo-cp-grid .arlo-cp-thumb--decal-arch{aspect-ratio:' + DECAL_ARCH_ASPECT + ';border-radius:' + DECAL_ARCH_RADIUS + '}' +
      '.arlo-cp-dup-hidden{display:none !important}';
    document.head.appendChild(styleEl);

    // Map of Uploadcare UUID → crop shape ('circle' | 'arch' | 'decal-arch') for the
    // line item it belongs to. Populated from /cart.js: an item is circle when it has
    // the _arlo_circle="true" property (written by arlo-photo-uploader.js for any
    // circle-crop uploader), OR its product name/handle contains "round" (fallback
    // that also covers the case where the flag doesn't reach the cart). Arch-style
    // items carry _arlo_shape="arch" or _arlo_shape="decal-arch" — passed through
    // as-is so each renders with its own ratio/radius. Matching per-UUID keeps it
    // precise even when a cart mixes shapes.
    var _shapeUuids = {};
    function uuidOf(u) {
      var m = String(u).match(/ucarecdn\.com\/([a-f0-9\-]+)/i);
      return m ? m[1].toLowerCase() : null;
    }
    function loadCircleData() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          (cart.items || []).forEach(function (item) {
            var props = item.properties || {};
            var name = ((item.product_title || item.title || '') + ' ' + (item.handle || '')).toLowerCase();
            var propShape = String(props._arlo_shape || '').toLowerCase();
            var isArchLike = propShape === 'arch' || propShape === 'decal-arch';
            var isCircle = !isArchLike && (String(props._arlo_circle).toLowerCase() === 'true' || name.indexOf('round') !== -1);
            if (!isArchLike && !isCircle) return;
            // Keep the exact shape id ('arch' vs 'decal-arch') rather than collapsing
            // both to 'arch' — the class applied below (arlo-cp-thumb--<shape>) needs
            // to match one or the other so the right ratio/radius CSS rule applies.
            var shape = isArchLike ? propShape : 'circle';
            // _arlo_shape_uuids scopes the shape to the exact photo UUID(s) written
            // by arlo-photo-uploader.js. WITHOUT this, every ucarecdn.com URL on the
            // line item would get the shape — including an unrelated canvas-png
            // personalised-message PNG on the same product, which should never be
            // shape-cropped. Only fall back to the old "every URL on the item" match
            // when the property is missing (older carts already in progress, or the
            // name-contains-"round" heuristic, which has no specific UUID to scope to).
            if (props._arlo_shape_uuids) {
              String(props._arlo_shape_uuids).split(',').forEach(function (id) {
                id = id.trim().toLowerCase();
                if (id) _shapeUuids[id] = shape;
              });
            } else {
              Object.keys(props).forEach(function (k) {
                var id = uuidOf(props[k]);
                if (id) _shapeUuids[id] = shape;
              });
            }
          });
        })
        .catch(function () {});
    }

    // Some cart apps (confirmed: Unicorn Cart) render each property as a
    // <dt>Photo 1</dt><dd>[url]</dd> pair instead of "Photo 1: [url]" in one text
    // node — so the "before" text on the URL's own text node comes up empty and the
    // "Photo N" marker below never gets set, silently disabling grid grouping.
    // Fallback: walk backward through preceding sibling elements of the node that
    // will hold the URL/image (this reaches the <dt> directly in the dl>div>dt,dd
    // pattern) and use the first one with non-empty text as the label.
    function findPrecedingLabel(textNode) {
      var el = textNode.parentNode && textNode.parentNode.previousElementSibling;
      while (el) {
        var t = (el.textContent || '').replace(/:\s*$/, '').trim();
        if (t) return t;
        el = el.previousElementSibling;
      }
      return '';
    }

    function scanAndReplace() {
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: function(n) {
          // Skip script, style, noscript, our own img already processed
          var tag = n.parentNode && n.parentNode.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
          if (n.parentNode && n.parentNode.dataset && n.parentNode.dataset.arloDone) return NodeFilter.FILTER_REJECT;
          return UCARECDN_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      }, false);

      var nodes = [];
      var n;
      while ((n = walker.nextNode())) nodes.push(n);

      nodes.forEach(function(textNode) {
        var match = textNode.nodeValue.match(UCARECDN_RE);
        if (!match) return;
        // Strip any existing Uploadcare transforms to get the base UUID URL
        var rawUrl = match[0];
        var baseMatch = rawUrl.match(/https?:\/\/ucarecdn\.com\/[a-f0-9\-]+(?:~\d+)?\//);
        var url = baseMatch ? baseMatch[0].replace(/\/$/, '') : rawUrl.replace(/\/$/, '');
        var id = uuidOf(url);
        var shape = id && _shapeUuids[id]; // 'circle' | 'arch' | 'decal-arch' | undefined
        // Circle/arch/decal-arch crops get a scale_crop matching their aspect ratio
        // (so the shape isn't stretched); everything else keeps the original
        // aspect-preserving resize. resize/480x (vs the old 120x) gives canvas-png
        // text thumbnails (e.g. a "Personalised Message") a high-res source to stay
        // legible when displayed — .arlo-cp-thumb's CSS max-width caps the actual
        // on-screen size.
        var thumb = shape === 'circle'
          ? url + '/-/scale_crop/240x240/center/-/quality/smart/'
          : shape === 'arch'
          ? url + '/-/scale_crop/200x246/center/-/quality/smart/'
          : shape === 'decal-arch'
          ? url + '/-/scale_crop/225x300/center/-/quality/smart/' // 225/300 = 0.75 = DECAL_ARCH_ASPECT
          : url + '/-/resize/480x/-/quality/smart/';
        // "before" = text sitting in the SAME node as the URL (e.g. "Photo 1: [url]"
        // all one text node) — if non-empty, it's re-inserted next to the image below,
        // exactly reproducing what was already there.
        // "labelForMarker" = the best label we can find AT ALL, including a fallback to
        // a separate <dt> sibling (see findPrecedingLabel) for cart apps like Unicorn
        // that render "<dt>Photo 1</dt><dd>[url]</dd>" as two elements. This is used
        // ONLY to test the photo-series marker below — it must NEVER be re-inserted as
        // text, because when it comes from the <dt> fallback that label is already
        // visible on its own; re-inserting it created a genuine duplicate ("Photo 1:
        // Photo 1", "Custom image: Custom image", "Personalised Message: Personalised
        // Message") and broke the row-cleanup regex further down, which in turn caused
        // hideDuplicateLabelRows() to hide the whole row — including the actual image.
        var before = textNode.nodeValue.replace(match[0], '').replace(/:\s*$/, '').trim();
        var labelForMarker = before || findPrecedingLabel(textNode);

        var frag = document.createDocumentFragment();
        if (before) frag.appendChild(document.createTextNode(before));
        var img = document.createElement('img');
        img.src = thumb;
        img.className = shape ? ('arlo-cp-thumb arlo-cp-thumb--' + shape) : 'arlo-cp-thumb';
        img.alt = 'Preview';
        // Only a genuine multi-photo upload property ("Photo 1", "Photo 2", ... — the
        // exact naming arlo-photo-uploader.js uses) should ever be swept into the grid
        // layout below. Without this marker, a lone photo sitting next to an unrelated
        // canvas-png property (e.g. "Personalised Message") gets miscounted as a second
        // "photo" and both get force-merged into a shared grid — squashing the message
        // PNG into a small square alongside the photo instead of rendering it separately.
        if (/^photo\s*\d+$/i.test(labelForMarker)) img.dataset.arloPhotoSeries = '1';
        frag.appendChild(img);

        var parent = textNode.parentNode;
        parent.replaceChild(frag, textNode);
        parent.dataset.arloDone = '1';
      });

      groupIntoGrids();
      hideDuplicateLabelRows();
    }

    // Unicorn Cart (and possibly other cart apps) renders a SECOND summary line for
    // image-type properties below the real thumbnail/grid — where the "value" shown
    // is just the property name repeated back (e.g. "Photo 1: Photo 1", "Custom
    // image: Custom image"), since the real value (a long ucarecdn.com URL) isn't
    // meant to be printed inline there. Once the actual image is showing above, that
    // line is pure redundant clutter. Only touches rows for known image-property
    // names (Photo N / Custom image) — leaves everything else (e.g. a genuine
    // "Personalised Message: <typed text>" row) alone.
    function hideDuplicateLabelRows() {
      var candidates = document.querySelectorAll('dt,dd,li,p,div,span,td,th');
      candidates.forEach(function (el) {
        if (el.dataset.arloDupChecked) return;
        el.dataset.arloDupChecked = '1';
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) return;
        var m = t.match(/^(.+?)\s*:\s*\1$/i);
        if (m && /^(photo\s*\d+|custom\s*image)$/i.test(m[1].trim())) {
          el.classList.add('arlo-cp-dup-hidden');
        }
      });
    }

    // For one thumb, the tightest ancestor that holds 2+ (ungridded) thumbs — i.e.
    // that item's photo list. We DON'T assume any wrapper class; groupIntoGrids then
    // keeps only the tightest such containers, so a parent spanning multiple line
    // items is never chosen (which previously merged different products' photos).
    function tightestMultiThumbAncestor(img) {
      var el = img.parentNode;
      while (el && el !== document.body) {
        if (el.querySelectorAll('.arlo-cp-thumb[data-arlo-photo-series]:not(.arlo-cp-gridded)').length >= 2) return el;
        el = el.parentNode;
      }
      return null;
    }

    // A row is safe to delete only if it is clearly just a photo label (e.g. "Photo 1:")
    // — never a product title, price, quantity, or link. Prevents nuking cart items.
    function isPhotoLabelRow(row) {
      if (!row) return false;
      if (row.querySelector('a,button,input,select')) return false;
      if (row.querySelector('img')) return false; // still holds a thumb
      var t = (row.textContent || '').trim();
      if (t.length > 24) return false;
      return t === '' || /^(photo|image|custom image)\s*\d*\s*:?$/i.test(t);
    }

    function groupIntoGrids() {
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.arlo-cp-thumb:not(.arlo-cp-gridded)'));
      var candidates = [];
      thumbs.forEach(function (img) {
        var c = tightestMultiThumbAncestor(img);
        if (c && candidates.indexOf(c) === -1) candidates.push(c);
      });

      // Keep only the TIGHTEST containers: drop any candidate that contains another
      // candidate. This guarantees we never pick a parent that spans multiple line
      // items (which would merge different products' photos into one grid).
      var containers = candidates.filter(function (c) {
        return !candidates.some(function (o) { return o !== c && c.contains(o); });
      });

      containers.forEach(function (container) {
        if (container.querySelector(':scope > .arlo-cp-grid')) return;
        // Only actual "Photo N" series thumbs go in the grid — an unrelated canvas-png
        // property (e.g. "Personalised Message") sharing this container must never be
        // swept in even if it happens to sit alongside 2+ real photos.
        var imgs = Array.prototype.slice.call(container.querySelectorAll('.arlo-cp-thumb[data-arlo-photo-series]'));
        if (imgs.length < 2) return;

        // Find the container's direct child that holds the first thumb — anchor the grid there.
        var anchor = imgs[0];
        while (anchor.parentNode && anchor.parentNode !== container) anchor = anchor.parentNode;

        var grid = document.createElement('div');
        grid.className = 'arlo-cp-grid';
        container.insertBefore(grid, anchor);

        imgs.forEach(function (img) {
          // Row = the container's direct child that this thumb lives in (the "Photo N:" line).
          var row = img;
          while (row.parentNode && row.parentNode !== container) row = row.parentNode;
          img.classList.add('arlo-cp-gridded');
          grid.appendChild(img);
          // Only remove the leftover row if it's clearly just a photo label — never
          // a title/price/quantity row.
          if (row && row.parentNode === container && isPhotoLabelRow(row)) {
            container.removeChild(row);
          }
        });
      });
    }

    function refresh() { loadCircleData().then(scanAndReplace); }

    document.addEventListener('DOMContentLoaded', refresh);

    // Re-run on any DOM change (catches Unicorn + any other AJAX cart). Reload the
    // circle data too, since the cart contents may have changed (item added/removed).
    var timer;
    var observer = new MutationObserver(function() {
      clearTimeout(timer);
      timer = setTimeout(refresh, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  // ── End Arlo cart property enhancer ─────────────────────────────────────────

  // ── Hide app-injected "Savings" line in the cart ────────────────────────────
  // The savings summary row is added by a third-party app (not the theme), so we
  // remove it in JS. Scoped to cart containers so real "Savings" text elsewhere is
  // left alone. Uses a MutationObserver because the app injects the row late.
  (function arloHideCartSavings() {
    function hideSavings() {
      var scopes = document.querySelectorAll('.cart, .quick-cart, [data-section-type="quick-cart"], form[action*="/cart"]');
      for (var s = 0; s < scopes.length; s++) {
        var els = scopes[s].querySelectorAll('*');
        for (var i = 0; i < els.length; i++) {
          var el = els[i];
          if (el.children.length === 0 && /^\s*savings\s*$/i.test(el.textContent || '')) {
            var row = el, done = false;
            for (var k = 0; k < 4 && row; k++) {
              if (row !== el && /saving/i.test(row.textContent) && /[$£€]/.test(row.textContent)) {
                row.style.display = 'none'; done = true; break;
              }
              row = row.parentNode;
            }
            if (!done && el.parentNode) el.parentNode.style.display = 'none';
          }
        }
      }
    }
    hideSavings();
    document.addEventListener('DOMContentLoaded', hideSavings);
    var t;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(hideSavings, 120); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  })();

  // ── "Others Also Bought" cards ──────────────────────────────────────────────
  // Rendered from this asset (not the cached quick-cart section) so it updates
  // live. Takes over the #arlo-recs container the section outputs: reads its data
  // attributes, fetches recommendations, and renders 2-up scrolling cards with
  // NEW / % OFF badges, colour swatches, sale price and an Add-to-cart button.
  (function arloCartRecs() {
    var STYLE_ID = 'arlo-recs-v2-style';
    function injectStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent = [
        '#arlo-recs{margin-bottom:20px}',
        '#arlo-recs .xs-wrap{padding:0 16px}',
        '#arlo-recs .xs-heading{font-weight:600;font-size:14px;margin:12px 0 10px}',
        '#arlo-recs .xs-scroller{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;padding-bottom:8px}',
        '#arlo-recs .xs-scroller::-webkit-scrollbar{height:6px}',
        '#arlo-recs .xs-scroller::-webkit-scrollbar-thumb{background:rgba(0,0,0,.18);border-radius:3px}',
        '#arlo-recs .xs-card{flex:0 0 26%;scroll-snap-align:start;display:flex;flex-direction:column}',
        '#arlo-recs .xs-imgwrap{position:relative;display:block;border-radius:8px;overflow:hidden;background:#f4f4f4}',
        '#arlo-recs .xs-img{width:100%;aspect-ratio:1/1;object-fit:cover;display:block}',
        '#arlo-recs .xs-badges{position:absolute;top:6px;left:6px;display:flex;flex-direction:column;gap:3px}',
        '#arlo-recs .xs-badge{font-size:9px;font-weight:700;color:#fff;padding:2px 6px;border-radius:12px;background:var(--color-button-primary-background,#2b5563)}',
        '#arlo-recs .xs-swatches{display:flex;gap:4px;margin:6px 0 3px}',
        '#arlo-recs .xs-swatch{width:10px;height:10px;border-radius:50%;border:1px solid rgba(0,0,0,.15)}',
        '#arlo-recs .xs-title{font-size:11px;line-height:1.3;color:inherit;text-decoration:none;display:block;margin-bottom:3px}',
        '#arlo-recs .xs-pricerow{font-size:11px;margin-bottom:6px}',
        '#arlo-recs .xs-price{font-weight:600}',
        '#arlo-recs .xs-compare{text-decoration:line-through;opacity:.6;margin-left:2px}',
        '#arlo-recs .xs-sale{color:var(--color-button-primary-background,#2b5563);margin-left:2px}',
        '#arlo-recs .xs-imglink{display:block}',
        '#arlo-recs .xs-add{position:absolute;right:6px;bottom:6px;width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:8px;letter-spacing:0.02em;background:var(--color-button-primary-background,#2b5563);color:var(--color-button-primary-text,#fff);text-decoration:none;box-shadow:0 1px 4px rgba(0,0,0,.3)}'
      ].join('');
      document.head.appendChild(s);
    }

    var PROT_IDS = [8053514436790, 8082449137846];
    var PROT_HANDLES = ['shipping-protection','shipping-insurance','order-armor','navidium-shipping-protection'];
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function colorHex(name) {
      var m = { purple:'#7e57c2', lilac:'#b39ddb', navy:'#1b2a4a', black:'#111', white:'#fff', blue:'#3f6fb0', red:'#c0392b', green:'#3a8f5a', mint:'#8fd3b6', pink:'#e59bb5', grey:'#9aa0a6', gray:'#9aa0a6', yellow:'#e6c34a', orange:'#e07b39', teal:'#2b8a8a', brown:'#8a5a3a', beige:'#e3d4bb', cream:'#f2ead5', silver:'#c8ccd0', gold:'#c9a24b', tan:'#d2b48c' };
      var k = String(name || '').toLowerCase();
      for (var key in m) { if (k.indexOf(key) !== -1) return m[key]; }
      return '#cfcfcf';
    }
    function swatches(p) {
      var opt = (p.options || []).filter(function (o) { return /colou?r/i.test(o.name); })[0];
      if (!opt || !opt.values || !opt.values.length) return '';
      return '<div class="xs-swatches">' + opt.values.slice(0, 6).map(function (v) {
        return '<span class="xs-swatch" style="background:' + colorHex(v) + '"></span>';
      }).join('') + '</div>';
    }

    function render(el, products, heading, cartIds) {
      var list = products.filter(function (p) {
        var isP = PROT_IDS.indexOf(p.id) !== -1 || PROT_HANDLES.indexOf(p.handle) !== -1 || (p.title || '').toLowerCase().indexOf('parcel') !== -1;
        return cartIds.indexOf(p.id) === -1 && p.available && !isP;
      }).slice(0, 10);
      if (!list.length) { el.style.display = 'none'; return; }
      var cards = list.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0] || {};
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=400' : '';
        var isNew = (p.tags || []).some(function (t) { return String(t).toLowerCase() === 'new'; });
        var cmp = v.compare_at_price || 0, onSale = cmp && cmp > v.price, pct = onSale ? Math.round((1 - v.price / cmp) * 100) : 0;
        var b = ''; if (isNew) b += '<span class="xs-badge">NEW</span>'; if (onSale) b += '<span class="xs-badge">' + pct + '% OFF</span>';
        var pr = onSale
          ? '<span class="xs-price">' + money(v.price) + '</span> <span class="xs-compare">' + money(cmp) + '</span> <span class="xs-sale">Sale</span>'
          : '<span class="xs-price">' + money(v.price) + '</span>';
        // .xs-imgwrap is a plain div (not a link) so the image link and the round
        // "ADD" dot can be two separate, non-nested <a> tags both pointing at the
        // product page — nesting an <a> inside an <a> is invalid HTML and makes
        // click targeting unreliable.
        return '<div class="xs-card"><div class="xs-imgwrap">'
          + (b ? '<div class="xs-badges">' + b + '</div>' : '')
          + '<a class="xs-imglink" href="' + p.url + '">' + (img ? '<img class="xs-img" src="' + img + '" alt="" loading="lazy">' : '') + '</a>'
          + '<a class="xs-add" href="' + p.url + '" aria-label="' + (p.title || '').replace(/"/g, '') + '">ADD</a>'
          + '</div>' + swatches(p)
          + '<a class="xs-title" href="' + p.url + '">' + p.title + '</a>'
          + '<div class="xs-pricerow">' + pr + '</div></div>';
      }).join('');
      // data-scroll-lock-ignore on the scroller: it's a genuinely scrollable
      // element (horizontal), so the drawer's body-scroll-lock must let touches
      // through here. Without it, whenever the cart content fits the screen
      // (updateScrollLockIgnore strips the exemption from .quick-cart__main-content
      // because there's nothing to scroll VERTICALLY), the lock swallowed touch
      // gestures over the recs too — cards visible but wouldn't swipe.
      el.innerHTML = '<div class="xs-wrap"><div class="xs-heading">' + heading + '</div><div class="xs-scroller" data-scroll-lock-ignore>' + cards + '</div></div>';
      el.style.display = '';
      el.setAttribute('data-arlo-v2', '1');
      // Cards now link straight to the product page (via xs-imgwrap / xs-title / xs-add)
      // instead of adding a bare variant to cart, so customers land on the product to
      // choose their own photos/text before it's added — these products need
      // personalization, they can't just be dropped into the cart as-is.
    }

    var _busy = false;
    function build() {
      var el = document.getElementById('arlo-recs');
      if (!el) return;
      if (el.getAttribute('data-arlo-v2') === '1' && el.querySelector('.xs-wrap')) {
        // 2026-07-23 fix: reset display defensively on the early-return path too.
        // The dead v1 script (now removed from quick-cart.liquid) used to set
        // display:none on this element from OUTSIDE render() 800ms after every
        // add, which this early return then left un-reset — the actual cause of
        // recs "flashing then disappearing". Nothing else should be touching
        // #arlo-recs's display anymore, but this costs nothing and guards
        // against a repeat of that exact failure mode.
        el.style.display = '';
        return; // already ours
      }
      var primaryId = el.dataset.recProductId; if (!primaryId) return;
      var cartIds = (el.dataset.cartProductIds || '').split(',').filter(Boolean).map(Number);
      var heading = el.dataset.heading || 'Others Also Bought';
      if (_busy) return; _busy = true;
      injectStyle();
      var overrides = window.arloCrossSellOverrides || [];
      var p = overrides.length
        ? Promise.all(overrides.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; }); })).then(function (rs) { return { products: rs.filter(Boolean) }; })
        : fetch('/recommendations/products.json?product_id=' + primaryId + '&intent=related&limit=10').then(function (r) { return r.json(); });
      p.then(function (data) { render(el, (data && data.products) || [], heading, cartIds); })
        .catch(function () {})
        .then(function () { _busy = false; });
    }

    document.addEventListener('DOMContentLoaded', build);
    // Fixed-delay fallback — kept as a safety net, but this is a guess, not a
    // guarantee the cart section has actually finished refreshing yet. A
    // personalised item (canvas-png text or an uploaded photo) takes longer
    // end-to-end to add — the artwork has to render/upload before the real
    // /cart/add.js call even happens — and produces a heavier cart section to
    // re-render (larger properties payload, photo thumbnail generation via
    // arloCartPreviews below). That made this 900ms guess fire too early
    // often enough to matter: "Others Also Bought" would silently stay empty
    // because build() ran against the OLD, pre-refresh #arlo-recs element.
    document.addEventListener('cart:item-added', function () { setTimeout(build, 900); });
    var rt;
    var rmo = new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(build, 200); });
    // 2026-07-23 fix: this used to observe document.documentElement — the
    // ENTIRE page, every mutation, forever. That's how "recs render, then
    // vanish a moment later" happened: the cart section can legitimately
    // refresh a SECOND time in quick succession after an add (e.g. the header
    // count refresh and the quick-cart refresh landing at slightly different
    // times), replacing the freshly-built #arlo-recs with a brand new, empty
    // placeholder. This same observer SHOULD have caught that second refresh
    // and rebuilt again — but watching the whole document means its 200ms
    // "things have gone quiet" timer was constantly getting reset by
    // unrelated churn elsewhere on the page (GA4, Meta Pixel, Bold Discounts,
    // the legacy Shopstorm app, etc. all mutate the DOM regularly), so it
    // rarely got a clean gap to actually fire. Scoping this to just the cart
    // drawer's own always-present outer shell (never itself replaced —
    // only its inner content is swapped by AJAX refreshes) means it reacts
    // ONLY to changes that could plausibly affect #arlo-recs, and isn't
    // drowned out by everything else happening on the page.
    var recsWatchRoot = document.querySelector('.quick-cart') || document.documentElement;
    rmo.observe(recsWatchRoot, { childList: true, subtree: true });
    build();

    // 2026-07-23 fix: reliable trigger, not a guess. arlo-options.js already
    // confirms — via its own MutationObserver on .quick-cart — the precise
    // moment the refreshed cart section HTML has actually landed in the DOM
    // (see openQuickCartWhenReady() there). Exposing build() here lets that
    // confirmed moment also kick off the recs rebuild directly, instead of
    // relying solely on the fixed-delay timer above, which is exactly what
    // was racing against slower personalised-item adds.
    window.arloRebuildCartRecs = build;
  })();

  // Set cookie
  function setCookieJS(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // Get cookie
  function getCookieJS(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
